import React, { useState, useEffect } from 'react';
import Footer from './footer';

// this only works when using customer SDK

export default (apiAsyncMethod, defaults = {}) => {
    const [totalItems, setTotalItems] = useState(0);
    const [currentItems, setCurrentItems] = useState([]);
    const [isRequesting, setRequesting] = useState(false);

    const [page, setPage] = useState(defaults.page || 1);
    const [limit, setLimit] = useState(defaults.limit || 25);
    const [criteria, setCriteria] = useState(defaults.criteria || {});
    const [orderBy, setOrderBy] = useState(defaults.orderBy || {});

    useEffect(() => {
        requestItems();
    }, []);

    const requestItems = async (queryProps) => {
        const q = { ...{ page, limit, criteria, orderBy }, ...queryProps };
        setRequesting(true);

        try {
            // assumes you are using the correct API
            let { _embedded, limit, total, ...r } = await apiAsyncMethod(q);
            let { items } = _embedded;

            

            setCurrentItems(items);
            setTotalItems(total);
            setRequesting(false);
            return true;
        } catch (error) {console.log(error);}

        setRequesting(false);
        return false;
    };

    const onPageSwitch = ({ page }) => {
        setPage(page);
        requestItems({ page });
    };

    const footer = (
        <Footer
            totalItems={totalItems}
            currentPage={page}
            limit={limit}
            onPageSwitch={onPageSwitch}
            isRequesting={isRequesting}
        />
    );

    const handleSetCriteria = (a) => {
        let n = { ...criteria, ...a };
        setCriteria({ ...criteria, ...a });
        return n;
    };

    return {
        footer,
        isRequesting,
        page,
        setPage,
        limit,
        setLimit,
        criteria,
        setCriteria: handleSetCriteria,
        currentItems,
        orderBy,
        setOrderBy,
        totalItems,
        requestItems,
        setTotalItems,
    };
};
